export default __webpack_public_path__ + "media/images/coworkr/favicons/icon152-f552a942fa442543dd164955a881fa76.png";